(function () {
  function showWidget() {
    let product = "";

    const url = new URL(window.location.href).searchParams;
    if (url.has("product")) {
      product = url.get("product");
    }

    CustomizerWidget.default.createWidget({
      apiKey:
        "ELgeeYJCcbh5QZe7LCu3hkg1eRKzytV37QQZIczpDOETb2XLxAFYyVhGYGnA0XlEmfLGL9jzqNEs2aGIrvUjGux9jOUVkSNJ",

      products: [product],

      onCancel: () => {
        // Nothing to do, return to the landing page.
      },

      onDone: (result) => {
        // Figure out the customization type, group vs individual.
        let recipes = [result.recipe];

        if (result.group) {
          recipes = result.group;
        }

        // Build the cart request.
        const cartData = { items: [] };

        // Process all recipes.
        recipes.forEach((recipe) => {
          // Add basic item data.
          const added = {
            quantity: recipe.quantity == null ? 1 : recipe.quantity,
            id: +recipe.variant.replace("gid://shopify/ProductVariant/", ""),
            properties: {},
          };

          // Store recipe data.
          added.properties["_Drive Type"] = "Primary";
          added.properties["_Drive Recipe ID"] = recipe.id;
          added.properties[
            "_Drive Recipe URL"
          ] = `https://cz.drrv.co/recipe/${recipe.id}.json`;

          // Add proof image links.
          if (recipe.views) {
            recipe.views.forEach((v) => {
              if (v.code.endsWith("Proof")) {
                added.properties[
                  `_Drive Proof ${v.code}`
                ] = `https:${v.previewJpg}`;
              }
            });
          }

          cartData.items.push(added);

          if (recipe.addons) {
            recipe.addons.forEach((addon) => {
              const other = {
                quantity: addon.quantity == null ? 1 : addon.quantity,
                id: +addon.variant.replace("gid://shopify/ProductVariant/", ""),
                properties: {},
              };

              // Store recipe data.
              other.properties["_Drive Type"] = "Personalization";
              other.properties["_Drive Recipe ID"] = recipe.id;

              cartData.items.push(other);
            });
          }
        });

        console.log(cartData.items);
        // Add to Shopify cart.
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cartData),
        }).then(() => {
          const cartUpdate = {
            attributes: {
              "_Drive Personalization": "Contains personalized items",
            },
          };

          fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(cartUpdate),
          }).then(() => {
            // Redirect to cart.
            window.location.href = "/cart";
          });
        });
      },
    });
  }

  // On page load, show the widget.
  window.addEventListener("DOMContentLoaded", () => {
    if (
      window.location.search &&
      window.location.search.indexOf("product") >= 0
    ) {
      showWidget();
    } else {
      // As a precaution, redirect to the homepage.
      window.location.href = "/";
    }
  });
})();
